import { useState } from 'react';

export default function ServiceTabs() {
  const [activeTab, setActiveTab] = useState<'physical' | 'daily'>('physical');

  const physicalCare = [
    '食事介助（食事の準備、食事中のサポート）',
    '入浴介助（全身浴、部分浴、清拭）',
    '排泄介助（トイレ介助、おむつ交換）',
    '更衣介助（着替えのお手伝い）',
    '体位変換・移乗介助',
    '服薬介助',
    '外出介助（通院同行など）'
  ];

  const dailySupport = [
    '掃除（居室、トイレ、浴室などの清掃）',
    '洗濯（衣類の洗濯、干し、たたみ、収納）',
    '買い物代行（日用品、食材の購入）',
    '調理（食事の準備、配膳、後片付け）',
    'ゴミ出し',
    '薬の受け取り',
    '生活必需品の整理整頓'
  ];

  return (
    <section className="py-24 bg-gray-50 observe-animation opacity-0">
      <div className="container mx-auto px-6 lg:px-12">
        <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-12 text-center">
          提供サービス
        </h2>

        <div className="max-w-5xl mx-auto">
          <div className="flex gap-4 mb-8 justify-center">
            <button
              onClick={() => setActiveTab('physical')}
              className={`px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 whitespace-nowrap cursor-pointer ${
                activeTab === 'physical'
                  ? 'bg-cyan-500 text-white shadow-lg'
                  : 'bg-white text-gray-600 hover:bg-gray-100'
              }`}
            >
              身体介護
            </button>
            <button
              onClick={() => setActiveTab('daily')}
              className={`px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 whitespace-nowrap cursor-pointer ${
                activeTab === 'daily'
                  ? 'bg-cyan-500 text-white shadow-lg'
                  : 'bg-white text-gray-600 hover:bg-gray-100'
              }`}
            >
              生活援助
            </button>
          </div>

          <div className="bg-white rounded-3xl shadow-lg p-10 lg:p-12">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="h-[400px] rounded-2xl overflow-hidden">
                <img
                  src={
                    activeTab === 'physical'
                      ? 'https://public.readdy.ai/ai/img_res/7cf9c6fd98ab0ab33c9c81bb6916aba6.jpg'
                      : 'https://readdy.ai/api/search-image?query=A%20professional%20Japanese%20home%20care%20worker%20helping%20with%20household%20tasks%20like%20cleaning%20or%20meal%20preparation%20in%20a%20bright%20modern%20Japanese%20home.%20The%20scene%20shows%20organized%20daily%20living%20support%20with%20the%20caregiver%20working%20efficiently.%20Simple%20clean%20background%20with%20natural%20lighting%20and%20tidy%20environment.%20Professional%20lifestyle%20photography%20style&width=700&height=600&seq=daily001&orientation=portrait'
                  }
                  alt={activeTab === 'physical' ? '身体介護' : '生活援助'}
                  className="w-full h-full object-cover"
                />
              </div>

              <div>
                <h3 className="text-3xl font-bold text-gray-900 mb-6">
                  {activeTab === 'physical' ? '身体介護' : '生活援助'}
                </h3>
                <p className="text-gray-700 leading-relaxed mb-8">
                  {activeTab === 'physical'
                    ? 'ご利用者様の身体に直接触れて行う介護サービスです。食事・入浴・排泄などの日常生活動作を、その方の状態に合わせて丁寧にサポートいたします。'
                    : '日常生活に必要な家事全般をサポートするサービスです。掃除・洗濯・買い物・調理など、ご利用者様が快適に生活できるようお手伝いいたします。'}
                </p>

                <ul className="space-y-3">
                  {(activeTab === 'physical' ? physicalCare : dailySupport).map((item, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <i className="ri-check-line text-2xl text-cyan-600 flex-shrink-0"></i>
                      <span className="text-gray-700">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
